import { memo, PropsWithChildren } from 'react';

const Layout = memo(function Layout({ children }: PropsWithChildren) {
  return (
    <div className="w-full h-full overflow-clip bg-backgroundCanvas">
      <div className="[--header-height:calc(--spacing(16))]">{children}</div>
    </div>
  );
});

export default Layout;
